var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "google-location-tab" },
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        !_vm.is_load
          ? _c("div", [
              _c("div", { staticClass: "google-header mb-4" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-start",
                  },
                  [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-1" },
                        [
                          _c("i", { staticClass: "fab fa-google fs-xxl mr-2" }),
                          _vm._v(" "),
                          _c("h3", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.google.title || _vm.location.title) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.address_text
                        ? _c("div", { staticClass: "text-muted" }, [
                            _c("i", {
                              staticClass: "fal fa-map-marker-alt mr-1",
                            }),
                            _vm._v(
                              "\n\n                            " +
                                _vm._s(_vm.address_text) +
                                "\n                        "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "google-buttons" }, [
                      _vm.maps_url
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-outline-primary btn-sm mr-2",
                              attrs: {
                                href: _vm.maps_url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fal fa-map-marker-alt mr-1",
                              }),
                              _vm._v(
                                "\n\n                            Google Maps\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.new_review_url
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-outline-warning btn-sm",
                              attrs: {
                                href: _vm.new_review_url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [
                              _c("i", { staticClass: "fal fa-star mr-1" }),
                              _vm._v(
                                "\n\n                            " +
                                  _vm._s(_vm.__t("WRITE_REVIEW")) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c("div", { staticClass: "google-card mb-3" }, [
                    _c("div", { staticClass: "google-card-title" }, [
                      _c("i", { staticClass: "fal fa-map-marker-alt mr-2" }),
                      _vm._v(
                        "\n\n                            " +
                          _vm._s(_vm.__t("ADDRESS")) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.address_text
                      ? _c("div", { staticClass: "google-card-value" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.address_text) +
                              "\n                        "
                          ),
                        ])
                      : _c("div", { staticClass: "text-muted" }, [
                          _vm._v(
                            "\n                            —\n                        "
                          ),
                        ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("div", { staticClass: "google-card mb-3" }, [
                    _c("div", { staticClass: "google-card-title" }, [
                      _c("i", { staticClass: "fal fa-globe mr-2" }),
                      _vm._v(
                        "\n\n                            " +
                          _vm._s(_vm.__t("WEBSITE")) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.google.website_url
                      ? _c("div", { staticClass: "google-card-value" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.google.website_url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.google.website_url) +
                                  "\n\n                                "
                              ),
                              _c("i", {
                                staticClass: "fal fa-external-link ml-1",
                              }),
                            ]
                          ),
                        ])
                      : _c("div", { staticClass: "text-muted" }, [
                          _vm._v(
                            "\n                            —\n                        "
                          ),
                        ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "google-card mb-3" },
                [
                  _c("div", { staticClass: "google-card-title" }, [
                    _c("i", { staticClass: "fal fa-phone mr-2" }),
                    _vm._v(
                      "\n\n                    " +
                        _vm._s(_vm.__t("PHONE")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.primary_phone
                    ? _c("div", { staticClass: "mb-1" }, [
                        _c(
                          "a",
                          { attrs: { href: "tel:" + _vm.primary_phone } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.primary_phone) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted ml-2" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.__t("PRIMARY")) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.additional_phones, function (phone) {
                    return _c("div", { key: phone, staticClass: "mb-1" }, [
                      _c("a", { attrs: { href: "tel:" + phone } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(phone) +
                            "\n                    "
                        ),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  !_vm.primary_phone && _vm.additional_phones.length === 0
                    ? _c("div", { staticClass: "text-muted" }, [
                        _vm._v("\n                    —\n                "),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "google-card mb-3" },
                [
                  _c("div", { staticClass: "google-card-title mb-3" }, [
                    _c("i", { staticClass: "fal fa-clock mr-2" }),
                    _vm._v(
                      "\n\n                    " +
                        _vm._s(_vm.__t("WORKING_HOURS")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.working_hours, function (row) {
                    return _c(
                      "div",
                      { key: row.day, staticClass: "hours-row" },
                      [
                        _c("div", { staticClass: "hours-day" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(row.title) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "hours-time",
                            class: {
                              "text-muted": !row.hasHours,
                            },
                          },
                          [
                            row.hasHours
                              ? [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(row.open) +
                                      "\n                            —\n                            " +
                                      _vm._s(row.close) +
                                      "\n                        "
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.__t("CLOSED")) +
                                      "\n                        "
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "google-card google-meta mb-3" }, [
                _c("div", { staticClass: "google-card-title mb-3" }, [
                  _c("i", { staticClass: "fal fa-info-circle mr-2" }),
                  _vm._v("\n\n                    Google\n                "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v(
                        "\n                            Place ID\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("code", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.google.place_id || "—") +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v(
                        "\n                            Location ID\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("code", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.location_id || "—") +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v(
                        "\n                            Store Code\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.store_code || "—") +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v(
                        "\n                            Status\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.location_status
                      ? _c(
                          "span",
                          {
                            staticClass: "badge",
                            class:
                              _vm.location_status === "OPEN"
                                ? "badge-success"
                                : "badge-secondary",
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.location_status) +
                                "\n                        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }